export default "__VITE_ASSET__Bx3EzrB6__"